import styled from 'styled-components'

import { Button } from '@thg-commerce/gravity-elements'

export const FormContainer = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  max-width: 960px;
  margin: 0 auto 30px;
`

export const SearchForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`

export const SearchInput = styled.input`
  padding: 12px 16px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;

  &:focus {
    outline: none;
    border-color: #000000;
    box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.2);
  }
`

export const SearchButton = styled(Button)`
  cursor: pointer;
  white-space: nowrap;
  min-width: 30%;
  height: 42px;
  text-transform: uppercase;

  &:hover {
    opacity: 0.8;
  }
`
export const Container = styled.div`
  width: 100%;
  min-height: 400px;
  margin: 20px 0;
`

export const FormTitle = styled.h2`
  font-size: 20px;
  margin-bottom: 16px;
  font-weight: 600;
  text-align: center;
`
